import Vue from 'vue'
import Vuex from 'vuex'
import services from './services'
const LOGIN = "LOGIN";
const LOGIN_SUCCESS = "LOGIN_SUCCESS";
const LOGOUT = "LOGOUT";


Vue.use(Vuex)

const state = {
    user: sessionStorage.getItem('user'),
    isLoggedIn: false,
    pending: false,
    services
};

const getters = {
    user: state => {
        return state.user
    }
};

const mutations = {

    logIn(state, user) {
        sessionStorage.setItem("user", JSON.stringify(user));
        state.user = sessionStorage.getItem('user');
        state.isLoggedIn=true;
    },

    logOut(state) {
        sessionStorage.removeItem('user');
        state.user = sessionStorage.getItem('user');
        state.isLoggedIn=false;
    }

};
const actions = {
    logIn({ commit }, user) {
        return new Promise(async (resolve, reject) => {

            try {
                await commit('logIn', user);
                resolve('Ok!')
            } catch (error) {
                reject(error)
            }
        })
    },
    logOut({ commit }) {
        return new Promise(async (resolve, reject) => {

            try {
                await commit('logOut');
                resolve('Ok!')
            } catch (error) {
                reject(error)
            }
        })

    }
};

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions
})




// WEBPACK FOOTER //
// ./src/store/index.js